import ENV from '@/config'
import axios, { AxiosInstance } from 'axios'
let controller = new AbortController()
export const instance: AxiosInstance = axios.create({
  signal: controller.signal,
  baseURL: ENV.HOST,
  // timeout: 10000,
  withCredentials: true,
})
instance.interceptors.request.use(function (config) {
  // config.headers.session_key = (window as any).session_key
  config.headers.is_business = import.meta.env.VITE_BUSINESS_HOST === window.location.host
  return config
})

instance.interceptors.response.use(
  function (response) {
    const isSuccess = response.data.success
    response.data = response.data.result
    if (isSuccess) {
      return response
    } else {
      throw Promise.reject(response)
    }
  },
  function (error) {
    error.response.data = error.response.data.error
    return Promise.reject(error)
  }
)
;(window as any).abortRequest = () => {
  controller.abort()
  controller = new AbortController()
  instance.defaults.signal = controller.signal
}
export function get(url: string, params?: any) {
  return instance
    .get(url, params)
    .then(({ data }) => data)
    .catch(({ response }) => Promise.reject(response && response.data ? response.data : response))
}

export function post(url: string, payload?: any) {
  return instance
    .post(url, payload)
    .then(({ data }) => data)
    .catch(({ response }) => Promise.reject(response && response.data ? response.data : response))
}

export function put(url: string, payload?: any, options?: any) {
  return instance
    .put(url, payload, options)
    .then(({ data }) => data)
    .catch(({ response }) => Promise.reject(response && response.data ? response.data : response))
}

export function deleteRequest(url: string, options?: any) {
  return instance
    .delete(url, options)
    .then(({ data }) => data)
    .catch(({ response }) => Promise.reject(response && response.data ? response.data : response))
}
instance.interceptors.response.use(
  function (response) {
    response.data = {
      result: response.data,
    }
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)
